module.exports = __webpack_public_path__ + "static/media/dog-footprints1.96006e69.svg";